import {
  FeaturesReady,
  IfFeatureEnabled,
  useFeature
} from "@growthbook/growthbook-react";
import React, { Fragment } from "react";
import {
  IGrowthbookFeatureVariationsProps,
  IGrowthbookFeatureWrapperProps,
  IGrowthbookIfFeatureEnabledProps
} from "./growthbook.types";

export const GrowthbookFeatureWrapper: React.FC<IGrowthbookFeatureWrapperProps> =
  ({ timeout, fallback, feature, variations }) => {
    return (
      // FeaturesReady return type is ReactNode which cannot be used as a component, ignoring the error until growthbook types get fixed
      // @ts-ignore
      <FeaturesReady timeout={timeout} fallback={fallback}>
        <GrowthbookFeatureVariations
          feature={feature}
          variations={variations}
          fallback={fallback}
        />
      </FeaturesReady>
    );
  };

const GrowthbookFeatureVariations: React.FC<IGrowthbookFeatureVariationsProps> =
  ({ variations, feature, fallback }) => {
    const { on, experimentResult } = useFeature(feature);
    if (!on) {
      return <>{fallback || null}</>;
    }
    return (
      <>
        {variations.map(({ variationId, component }) => {
          return experimentResult?.variationId === variationId ? (
            <Fragment key={`${feature}_${variationId}`}>{component}</Fragment>
          ) : null;
        })}
      </>
    );
  };

export const GrowthbookIfFeatureEnabled: React.FC<IGrowthbookIfFeatureEnabledProps> =
  ({ timeout, fallback, feature, children }) => {
    return (
      // FeaturesReady return type is ReactNode which cannot be used as a component, ignoring the error until growthbook types get fixed
      // @ts-ignore
      <FeaturesReady timeout={timeout} fallback={fallback}>
        <IfFeatureEnabled feature={feature}>{children}</IfFeatureEnabled>
      </FeaturesReady>
    );
  };
